import { Component, OnInit, Input, ViewChild, OnChanges } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { RequestRecognition } from '../shared/request-recognition.model';

@Component({
  selector: 'app-view-requests-deny',
  templateUrl: './view-requests-deny.component.html',
  styleUrls: ['./view-requests-deny.component.scss']
})
export class ViewRequestsDenyComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['fechaSolicitud', 'cedula', 'nombre', 'materiaPorRecon', 'institucion', 'justificacion'];

  messageError: String = '';
  claseMessage: String = 'messaje-error';
  dataSource: MatTableDataSource<RequestRecognition>;

  @Input() requests: RequestRecognition[];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor() {
    this.setTable();
   }

  ngOnInit() {
    this.setTable();
  }

  private setTable() {
    this.dataSource = new MatTableDataSource(this.requests);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

  }

  ngOnChanges() {
    this.setTable();
  }

}
